module.exports = __webpack_public_path__ + "img/nodata.2c08ec7c.png";